import { Box } from '@mui/material'
import { FormikProps } from 'formik'
import { ConfirmationCodeFormInterface } from '~/src/types/forms/ConfirmationCodeFormInterface'
import FormikOTPInput from '~/src/components/mui-wrappers/fields/FormikOTPInput'

interface Props {
  form: FormikProps<ConfirmationCodeFormInterface>,
  fieldsColor: 'container' | 'content',
}

const ConfirmationCodeFormFields = ({ form, fieldsColor = 'content' }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        pb: 4
      }}
    >
      <FormikOTPInput
        OTPInputProps={{
          form,
          numberOfInputs: 6,
          sx: {},
          color: fieldsColor,
          name: 'confirmationCode',
          inputMode: 'email'
        }}
      />
    </Box>
  )
}

export default ConfirmationCodeFormFields
